<ng-container *ngTemplateOutlet="routerOutlet"></ng-container>

<ng-template #routerOutlet>
  <ng-content select="[outOfTemplateContent]"></ng-content>
  <div class="offcanvas-header">
    <div
      class="offcanvas-title"
      id="offcanvasComponentLabel">
      <ng-content select="[title]"></ng-content>
    </div>
    <ng-content select="[headerExtra]"></ng-content>
    <div
      ngbTooltip="Waiting for background tasks to complete"
      [disableTooltip]="!closeBtnDisabled">
      <button
        id="offcanvasCloseBtn"
        type="button"
        class="btn-close"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
        [disabled]="closeBtnDisabled"
        (click)="close()"></button>
    </div>
  </div>
  <div class="offcanvas-body">
    <ng-content select="[body]"></ng-content>
  </div>
</ng-template>
